import { useQuery } from "@tanstack/react-query";
import { api } from "utils/api";
import { Artist } from "../types";
import { artistKeys } from "./queryKeys";

const getArtistById = (artistId?: string) =>
  artistId
    ? api.get<Artist>(`/artists/${artistId}`)
    : Promise.reject(new Error("Invalid artist id"));

const useArtist = (artistId?: string) =>
  useQuery({
    queryKey: artistKeys.detail(artistId),
    queryFn: () => getArtistById(artistId),
    enabled: !!artistId,
  });

export { useArtist };
